/* @flow */
import * as React from 'react';

const MapAlt1 = props => (
  <svg
    width={84}
    height={81}
    viewBox="0 0 84 81"
    fillRule="evenodd"
    strokeWidth={3}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#DEDEDE"
      points="2.233 70.465 2.15 76.215 28.725 69.712 54.975 79.154 81.554 69.712 81.637 63.962 76.642 61.848 28.115 60.777"
    />
    <polygon
      stroke="#1C1F34"
      points="2.233 70.465 2.15 76.215 28.725 69.712 54.975 79.154 81.554 69.712 81.637 63.962 76.642 61.848 28.115 60.777"
    />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      points="72.788 2.598 50.691 11.027 29.936 1.585 8.854 8.088 2.233 70.466 28.809 63.962 55.058 73.404 81.638 63.962"
    />
    <path stroke="#F8F8F9" d="M50.691,11.027 L55.059,73.404" />
    <path stroke="#F8F8F9" d="M29.248,1.585 L29.247,63.962" />
    <polyline
      stroke="#1C1F34"
      points="4.101 52.261 2.233 70.465 28.809 63.962 55.058 73.404 81.637 63.962 70.817 3.699"
    />
    <polyline
      stroke="#1C1F34"
      points="70.511 3.82 50.691 11.026 29.936 1.585 8.854 8.088 4.013 52.933"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M59.993,23.466 C59.993,12.991 51.502,4.5 41.026,4.5 C30.553,4.5 22.062,12.991 22.062,23.466 C22.062,33.941 30.553,42.432 41.026,42.432 C51.502,42.432 59.993,33.941 59.993,23.466"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M49.4,17.601 C47.265,15.466 43.806,15.466 41.672,17.601 L41,18.273 L40.328,17.601 C38.195,15.466 34.734,15.466 32.6,17.601 C30.467,19.735 30.467,23.194 32.6,25.329 L33.272,26 L39.483,32.211 C40.321,33.049 41.679,33.049 42.517,32.211 L48.728,26 L49.4,25.329 C51.533,23.194 51.533,19.735 49.4,17.601"
    />
    <path
      stroke="#1C1F34"
      d="M59.993,23.466 C59.993,12.991 51.502,4.5 41.026,4.5 C30.553,4.5 22.062,12.991 22.062,23.466 C22.062,33.941 30.553,42.432 41.026,42.432 C51.502,42.432 59.993,33.941 59.993,23.466 Z"
    />
    <path stroke="#1C1F34" d="M41.027,43.709 L41.027,52.91" />
  </svg>
);

export default MapAlt1;



// WEBPACK FOOTER //
// ./src/assets/images/icons/map-alt1.js